import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import StepperComponent from '@yaydoo/react-components/lib/components/Stepper';

import { accountsPayableLinkStep, QueryParams } from '@constants/accountsPayableLink';
import useStore from '@hooks/useStore';
import getUrlParam from '@utils/getUrlParam';

import useStyles from './styles';

export interface IStepper {}

const Stepper: FC<IStepper> = () => {
  const css = useStyles();
  const { accountsPayableLink } = useStore();
  const { t } = useTranslation();
  const { status } = accountsPayableLink;
  const titleEmpty = '';
  const translationRoot = 'accountsPayable.stepper';
  const fundingRequestStep = getUrlParam(QueryParams.CONFIRM)
    ? 'fundingRequestVariant'
    : 'fundingRequest';

  const STEP = [
    {
      title: t(`${translationRoot}.validation.title`),
      subtitle: t(`${translationRoot}.validation.subtitle`),
    },
    {
      title: t(`${translationRoot}.${fundingRequestStep}.title`),
      titleSection: t(`${translationRoot}.${fundingRequestStep}.titleSection`),
      subtitle: t(`${translationRoot}.${fundingRequestStep}.subtitle`),
    },
    {
      title: t(`${translationRoot}.operationInProcess.title`),
      subtitle:
        'No olvides refrescar constantemente la página para estar al tanto de las dispersiones.',
    },
    {
      title: t(`${translationRoot}.operationCompleted.title`),
      subtitle:
        'A continuación, te mostramos la lista de transacciones que lograron dispersarse, y aquellas que no.',
    },
  ];
  return (
    <div className={css.card}>
      <div className={css.containerStepper}>
        <StepperComponent
          className={css.stepper}
          activeStep={accountsPayableLinkStep[status]}
          emphasis
          headingPosition="top"
          inlineVariant
          orientation="horizontal"
          steps={[
            {
              title: t(`${translationRoot}.validation.title`),
            },
            {
              title: t(`${translationRoot}.fundingRequest.title`),
            },
            {
              title: t(`${translationRoot}.operationInProcess.title`),
            },
            {
              title: t(`${translationRoot}.operationCompleted.title`),
            },
          ]}
        />
      </div>
      <div className={css.containerSubtitle}>
        <span className={css.titleStep}>
          {STEP[accountsPayableLinkStep[status]]?.titleSection ||
            STEP[accountsPayableLinkStep[status]]?.title ||
            titleEmpty}
        </span>
        <span className={css.subtitleStep}>
          {STEP[accountsPayableLinkStep[status]]?.subtitle || titleEmpty}
        </span>
      </div>
    </div>
  );
};

export default Stepper;
